import { Button, theme, Typography } from "antd";
import { ContainerComponent, RowComponent } from "../../../components";

export const SuccessUseCasePartial = ({ title, description, imageSrc }) => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  return (
    <ContainerComponent
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "scale(1.03)";
        e.currentTarget.style.boxShadow = "0 4px 15px rgba(0, 0, 0, 0.1)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "scale(1)";
        e.currentTarget.style.boxShadow = "none";
      }}
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        width: "100%",
        maxWidth: 600,
        borderRadius: 16,
        cursor: "pointer",
        border: `1px solid ${colorBgContainer}`,
        backgroundColor: "#ffffff",
        overflow: "hidden",
        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
      }}
    >
      <img
        src={imageSrc}
        alt={title}
        style={{
          width: "30%",
          height: "auto",
          objectFit: "cover",
          margin: "0 0 0 10px",
          borderRadius: 8,
        }}
      />

      <RowComponent
        style={{
          flex: 1,
          flexDirection: "column",
          padding: 16,
          justifyContent: "justify",
          textAlign: "left",
        }}
      >
        <Typography.Title level={5} style={{ margin: 0, color: "var(--color-primary)" }}>
          {title}
        </Typography.Title>
        <Button
          type="link"
          style={{
            padding: 0,
            color: "var(--color-secondary)",
            fontWeight: "bold",
            justifyContent: "left",
          }}
        >
          Ver caso de éxito
        </Button>
      </RowComponent>
    </ContainerComponent>
  );
};
